  //  Tones map to .om-mcp-t-* classes in the stylesheet:
  //    key    #84ADFF   JSON property names
  //    str    #FFCBD3   string and number values
  //    method #FFADB9   HTTP verbs
  //    muted  #98A2B3   comments and header names
  
const JSON_TOKEN = /("(?:\\.|[^"\\])*")(\s*:)?|(-?\d+(?:\.\d+)?)|\b(true|false|null)\b/g;

const HTTP_METHOD = /^(POST|GET|PUT|PATCH|DELETE|HEAD|OPTIONS)(\s|$)/;
const HTTP_HEADER = /^([A-Za-z][A-Za-z0-9-]*:)(\s?)/;

export const tokenizePlain = (code) =>
  code.split("\n").map((line) => [{ t: line }]);

export const tokenizeJson = (code) =>
  code.split("\n").map((line) => {
    const segments = [];
    let cursor = 0;
    let match;

    JSON_TOKEN.lastIndex = 0;

    while ((match = JSON_TOKEN.exec(line)) !== null) {
      if (match.index > cursor) {
        segments.push({ t: line.slice(cursor, match.index) });
      }

      if (match[1] && match[2]) {
        // A quoted string followed by a colon is a property name
        segments.push({ t: match[1], tone: "key" });
        segments.push({ t: match[2] });
      } else if (match[1]) {
        segments.push({ t: match[1], tone: "str" });
      } else {
        segments.push({ t: match[0], tone: "str" });
      }

      cursor = match.index + match[0].length;
    }

    if (cursor < line.length) {
      segments.push({ t: line.slice(cursor) });
    }

    return segments.length > 0 ? segments : [{ t: line }];
  });

export const tokenizeHttp = (code) =>
  code.split("\n").map((line) => {
    if (line.trimStart().startsWith("//")) {
      return [{ t: line, tone: "muted" }];
    }

    const method = line.match(HTTP_METHOD);

    if (method) {
      return [
        { t: method[1], tone: "method" },
        { t: line.slice(method[1].length) },
      ];
    }

    const header = line.match(HTTP_HEADER);

    if (header) {
      return [
        { t: header[1], tone: "muted" },
        { t: line.slice(header[1].length) },
      ];
    }

    return [{ t: line }];
  });

const TOKENIZERS = {
  json: tokenizeJson,
  http: tokenizeHttp,
  plain: tokenizePlain,
};

export const tokenize = (code, mode = "plain") =>
  (TOKENIZERS[mode] || tokenizePlain)(code);

export default tokenize;